"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$useFileAPI = props.useFileAPI,
      useFileAPI = _props$useFileAPI === void 0 ? false : _props$useFileAPI,
      drag = props.drag;
  return _react["default"].createElement("span", {
    className: "bg-tips-w"
  }, _react["default"].createElement("span", {
    className: "w-bold"
  }, "\u70B9\u51FB", useFileAPI && drag ? '或拖拽' : '', "\u4E0A\u4F20"));
};

exports["default"] = _default;